import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MobileCryptoLiveTrade from './MobileCryptoLiveTrade/MobileCryptoLiveTrade';
import MobileForexLiveTrade from './MobileForexLiveTrade/MobileForexLiveTrade';
import MobileMetalsLiveTrade from './MobileMetalsLiveTrade/MobileMetalsLiveTrade';
import MobileStockLiveTrade from './MobileStockLiveTrade/MobileStockLiveTrade';

const MobilePopularMarketLiveTrade = () => {
    const { id } = useParams();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (id) {
      fetch(`https://api.wlffinance.org/api/user/trade/market/hot/view/${id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          setData(data?.data);
        });
    }
  }, [id]);
  
  return <>
  {data?.market === "Crypto" && <MobileCryptoLiveTrade data={data} />}
  {data?.market === "Forex" && <MobileForexLiveTrade data={data} />}
  {data?.market === "Metal" && <MobileMetalsLiveTrade data={data} />}
  {data?.market === "Stock" && <MobileStockLiveTrade data={data}  />}
  </>;
};

export default MobilePopularMarketLiveTrade;